export default "<span>{{ message }}</span>\r\n";